function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import { Component, cloneElement } from "react";
import omit from "lodash.omit";
export const TooltipTargetRef = "TooltipTarget";
const DELAY_TIMEOUT = 1000;
export default class TooltipTarget extends Component {
  handleMouseMove() {
    const {
      children,
      delay,
      showTooltip
    } = this.props;
    const {
      onMouseMove = () => {}
    } = children.props;

    if (delay && !this.showTimeout) {
      this.showTimeout = setTimeout(showTooltip, DELAY_TIMEOUT);
    }

    if (!delay) showTooltip();
    onMouseMove(...arguments);
  }

  handleMouseLeave() {
    const {
      children,
      hideTooltip
    } = this.props;
    const {
      onMouseLeave = () => {}
    } = children.props;

    if (this.showTimeout) {
      clearTimeout(this.showTimeout);
      this.showTimeout = undefined;
    }

    hideTooltip();
    onMouseLeave(...arguments);
  }

  handleClick() {
    const childClick = this.props.children.props.onClick;
    const {
      onClick
    } = this.props;

    if (childClick) {
      childClick(...arguments);
    }

    if (onClick) {
      onClick(...arguments);
    }
  }

  render() {
    const {
      children,
      ...rest
    } = this.props;
    return /*#__PURE__*/cloneElement(children, { ...omit(rest, ["delay", "hideTooltip", "showTooltip"]),
      onMouseMove: this.handleMouseMove.bind(this),
      onMouseLeave: this.handleMouseLeave.bind(this),
      onClick: this.handleClick.bind(this)
    });
  }

}

_defineProperty(TooltipTarget, "typeRef", TooltipTargetRef);